/**
 * Shared Framer Motion animation variants and smooth deceleration curve for User Dashboard pages.
 */
export const SMOOTH_EASE = [0.16, 1, 0.3, 1];

export const getDashboardVariants = (shouldReduceMotion = false) => {
  return {
    headerContainerVariants: {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: shouldReduceMotion ? 0 : 0.12,
        },
      },
    },

    textFadeUpVariants: {
      hidden: shouldReduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 16 },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: shouldReduceMotion ? 0 : 0.6,
          ease: SMOOTH_EASE,
        },
      },
    },

    statContainerVariants: {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: shouldReduceMotion ? 0 : 0.1,
          delayChildren: shouldReduceMotion ? 0 : 0.08,
        },
      },
    },

    statCardVariants: {
      hidden: shouldReduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: shouldReduceMotion ? 0 : 0.65,
          ease: SMOOTH_EASE,
        },
      },
    },

    sectionLeftVariants: {
      hidden: shouldReduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          delay: shouldReduceMotion ? 0 : 0.2,
          duration: shouldReduceMotion ? 0 : 0.7,
          ease: SMOOTH_EASE,
        },
      },
    },

    sectionRightVariants: {
      hidden: shouldReduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          delay: shouldReduceMotion ? 0 : 0.28,
          duration: shouldReduceMotion ? 0 : 0.7,
          ease: SMOOTH_EASE,
        },
      },
    },

    tableBodyVariants: {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: shouldReduceMotion ? 0 : 0.055,
          delayChildren: shouldReduceMotion ? 0 : 0.1,
        },
      },
      exit: {
        opacity: 0,
        transition: { duration: 0.3, ease: SMOOTH_EASE },
      },
    },

    tableRowVariants: {
      hidden: shouldReduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 18 },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: shouldReduceMotion ? 0 : 0.75,
          ease: [0.22, 1, 0.36, 1],
        },
      },
    },
  };
};
